import script from "./DrupalToken.vue?vue&type=script&lang=js"
export * from "./DrupalToken.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__